import "./header.scss";

export function Header() {
  return (
    <>
      <header>
        <h1>
          <span className="sticker" data-text="Silly Strings">
            <span className="header-title">Silly Strings</span>
          </span>
        </h1>
        <h2 className="subtitle">Transform text to silly formats.</h2>
      </header>
    </>
  );
}
